export default __webpack_public_path__ + "static/media/warning-modal-icon.c1aa932e.svg";